import React from "react";
import PropTypes from "prop-types";
import VerticalBarChart from "./Chart";

const labels = [
  ...["0-1", "1-5", "5-10", "10-20"],
  ...["20-30", "30-40", "40-50", "50-60", "60-70"],
  ...["70-80", "80-90", "90-100"],
];

function fixLabel(label) {
  return label === "<1" ? "0-1" : label;
}

function AgeChart({ data, ...rest }) {
  const arr = (data || []).map((x) => ({ ...x, key: fixLabel(x.key) }));
  const sums = labels.reduce((a, i) => a.set(i, 0), new Map());
  const dict = arr.reduce((a, i) => a.set(i.key, a.get(i.key) + i.value), sums);
  const items = labels.map((x) => ({ key: x, value: dict.get(x) || 0 }));
  const hasData = arr.length > 0;
  const buckets = labels.map((x) => x.split("-").map((y) => parseInt(y, 10)));

  function getAgeBucket(ageStr) {
    const age = parseInt(ageStr, 10);
    if (age === 100) return "90-100";
    const bucket = buckets.find(([min, max]) => age >= min && age < max);
    return bucket ? bucket.join("-") : false;
  }

  return (
    <VerticalBarChart
      {...rest}
      getNormalizedLabel={(age) => getAgeBucket(age)}
      data={hasData ? items : []}
      limit={15}
    />
  );
}

AgeChart.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({})),
};

AgeChart.defaultProps = {
  data: [],
};

export default AgeChart;
